export enum ShipmentTabs {
  DETAILS = "details",
  PRODUCTS = "products",
  SSCC = "sscc",
  COMMUNICATIONS = "communications",
  COSTING = "costing",
  DOCUMENTS = "documents",
  HISTORY = "history",
  VOYAGE = "voyage",
  MAP = "map",
  ACTIVITY = "activity",
}
